import React from 'react';

export default () => <svg width="100px" height="100px"
    viewBox="0 0 100 100" >
    <path d="M31.14 64.77c0,-2.32 4.06,-2.62 4.11,0.15 0.13,6.71 5.36,12.44 12.24,12.4 2.1,-0.01 2.73,2.24 1.61,3.47 -3.24,3.58 -17.96,-4.22 -17.96,-15.09l0 -0.93zm42.21 -8.35c-3.51,-12.03 -23.22,-37.32 -23.22,-44.05 -0.19,0.22 -0.18,0.42 -0.32,0.84 -6.23,14.97 -24.25,35.96 -24.25,49.77 0,13.17 9.73,24.65 23.33,24.65 17.95,0 29.22,-14.91 24.46,-31.21z" />
</svg>